
import { defineComponent } from "vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import api from "@/services/api";
import LoadingReportInfoDialog from "@/components/info/ReportInfoDialog.vue";
import ContainerReportInfoDialog from "@/components/info/ContainerReportInfoDialog.vue";
import DxButton from "devextreme-vue/button";

export default defineComponent({
  components: {
    DxLoadPanel,
    LoadingReportInfoDialog,
    ContainerReportInfoDialog,
    DxButton,
  },
  props: {
    reportType: { required: true },
  },
  methods: {
    onSwitchChange() {
      if (this.isSettingsOpen === true) this.isSettingsOpen = false;
      else this.isSettingsOpen = true;
    },
    onShowInfo() {
      this.$refs.infoDialog.open();
    },
    createViewer() {
      (
        window as any
      ).Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile(
        `${window.location.protocol}//${window.location.host}/stimulsoft/localization/ru.xml`
      );
      const options = new (window as any).Stimulsoft.Viewer.StiViewerOptions();
      options.toolbar.showAboutButton = false;
      options.appearance.scrollbarsMode = true;
      options.height = "1200px";

      this.viewer = new (window as any).Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );

      this.viewer.renderHtml("viewer");
      this.viewer.showProcessIndicator();
    },
    async getSchemeCount(
      planId: any,
      containerId: any,
      schemeId: any,
      options: any
    ) {
      const { data } = await api.get(
        `/LoadingReport/GetSchemeCount`,
        {
          params: {
            planId: planId,
            containerId: containerId,
            schemeId: schemeId,
            orderId: options.orderId,
            nomenclatureId: options.nomenclatureId,
            nomenclatureName: options.nomenclatureName,
            packageLength: options.packageLength,
            packageCut: options.packageCut
          },
        }
      );
      return data;
    },
    async fillReportData(
      planId: any,
      containerId: any,
      schemeId: any,
      showName: any,
      options: any
    ) {
      this.report = new (window as any).Stimulsoft.Report.StiReport();
      this.report.loadFile(`/${this.reportType}/Get${this.reportType}Template`);
      if (this.stopping)
            return

      const dataSetName = "Data";
      const dataSet = new (window as any).Stimulsoft.System.Data.DataSet(
        dataSetName
      );
      if (this.stopping)
            return
      const { data } = await api.get(
        `/${this.reportType}/Get${this.reportType}Data`,
        {
          params: {
            planId: planId,
            containerId: containerId,
            schemeId: schemeId,
            showName: showName,
            orderId: options.orderId,
            nomenclatureId: options.nomenclatureId,
            nomenclatureName: options.nomenclatureName,
            packageLength: options.packageLength,
            packageCut: options.packageCut,
          },
        }
      );
      if (this.stopping)
            return

      dataSet.readJson(data);
      if (this.stopping)
            return

      this.report.dictionary.databases.clear();
      this.report.regData(dataSetName, dataSetName, dataSet);
      if (this.stopping)
            return
      this.report.dictionary.synchronize();
      if (this.stopping)
            return
    },
    renderReport() {
      if (this.viewer && this.report) {
        this.report.renderAsync(() => {
          if (this.stopping)
            return
          this.viewer.report = this.report;
          this.loading = false;
          this.timeMessage = "";
          this.endTime = new Date().getTime();
          const reportData = (this as any).$store.state.reportData.reportData;
          let time = (this.endTime - this.startTime) / (1000 * this.schemeCount);
          if (this.reportType == "LoadingReport" && this.schemeCount != 0) {
            const temp = {
              data: {
                generationTime: this.schemeCount < 10 ? time / 2 : time,
                generationTimePdf: reportData.generationTimePdf ? reportData.generationTimePdf : null,
              },
            };
            (this as any).$store.dispatch("reportData/setReportData", temp);
          }
        });
      }
    },
    setTimeMessage(generationTime: any){
      if (this.schemeCount) {
        const time = Math.round(2 * this.schemeCount);
        this.timeMessage = time > 60 
          ? "\nПриблизительное время формирования отчета - " + Math.floor(time/60) + " мин " + Math.round(time%60) + " сек."
          : "\nПриблизительное время формирования отчета - " + Math.round(time%60) + " сек."
      }
      else {
        this.timeMessage = "";
      }
    },
    async onReport(
      planId: any,
      options: any,
      containerId: any,
      schemeId: any,
      showName: any,
    ) {
      if (this.reportType == "LoadingReport"){
        const reportData = (this as any).$store.state.reportData.reportData;
        this.schemeCount = await this.getSchemeCount(planId, containerId, schemeId, options);
        let time = null;
        if (reportData.generationTime != null){
          time =  this.schemeCount < 10 ? reportData.generationTime * 2 : reportData.generationTime;
        }
        this.setTimeMessage(time)
      }
      this.loading = true;
      this.stopping = false;
      this.startTime = new Date().getTime();
      await this.fillReportData(planId, containerId, schemeId, showName, options);
      if(this.stopping)
        return;
      this.renderReport();
    },
    async onDownload(
      planId: any,
      options: any,
      containerId: any,
      schemeId: any,
      showName: any,
    ) {
      const reportData = (this as any).$store.state.reportData.reportData;
      this.schemeCount = await this.getSchemeCount(planId, containerId, schemeId, options);
      this.setTimeMessage(reportData.generationTimePdf)
      this.loading = true;
      this.stopping = false;
      this.startTime = new Date().getTime();
      const { data } = await api.get(`/${this.reportType}/GetReport`, {
        responseType: "blob",
        params: {
          planId: planId,
          containerId: containerId,
          schemeId: schemeId,
          showName: showName,
          orderId: options.orderId,
          nomenclatureId: options.nomenclatureId,
          nomenclatureName: options.nomenclatureName,
          packageLength: options.packageLength,
          packageCut: options.packageCut,
        },
      });
      if(this.stopping)
        return;
      let blob = new Blob([data], { type: "application/octet-stream" });
      let link = document.createElement("a");
      if(this.stopping)
        return;
      link.href = window.URL.createObjectURL(blob);
      if(this.stopping)
        return;
      link.download = `Report.pdf`;
      link.click();
      link.remove();
      this.loading = false;
      this.timeMessage = "";
      this.endTime = new Date().getTime();
      if (this.schemeCount != 0) {
        const temp = {
          data: {
            generationTime: reportData.generationTime ? reportData.generationTime : null,
            generationTimePdf: (this.endTime - this.startTime) / (1000 * this.schemeCount),
          },
        };
        (this as any).$store.dispatch("reportData/setReportData", temp);
      }
    },
    onStop() {
      this.stopping = true;
      this.loading = false;
    },
  },
  created() {
    (window as any).Stimulsoft.Base.StiLicense.key =
      process.env.VUE_APP_STIMULSOFT_KEY;
  },
  mounted() {
    this.createViewer();
  },
  data() {
    return {
      schemeCount: null,
      startTime: null,
      endTime: null,
      isSettingsOpen: true,
      loading: false,
      stopping: false,
      report: {},
      viewer: {},
      loadingPanelPosition: { of: "#loadingPanelPlace" },
      timeMessage: "",
    };
  },
});
